<template>
  <div
    class="play-row"
    :class="[
      alignH ? `play-row--justify-${alignH}` : null,
      alignV ? `play-row--align-${alignV}` : null,
      { 'play-row--no-gutters': noGutters },
    ]"
  >
    <slot />
  </div>
</template>

<script>
/**
 * PlayRow — flex row of <PlayCol>s for the Play system.
 *
 * Replaces bootstrap-vue's <b-row>. A 12-column flexbox row with gutters.
 * `alignH` maps to justify-content (start/center/end/between/around), `alignV`
 * to align-items (start/center/end/stretch), `noGutters` removes the spacing.
 *
 * VUE3-MIGRATION: nothing Vue 2-specific — already Vue 3-safe.
 */
export default {
  name: 'PlayRow',
  props: {
    /** Horizontal distribution → justify-content */
    alignH: {
      type: String,
      default: '',
      validator: v => ['', 'start', 'center', 'end', 'between', 'around'].includes(v),
    },
    /** Vertical alignment → align-items */
    alignV: {
      type: String,
      default: '',
      validator: v => ['', 'start', 'center', 'end', 'stretch'].includes(v),
    },
    noGutters: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.play-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;

  &--no-gutters {
    margin-right: 0;
    margin-left: 0;

    ::v-deep > .play-col { padding-right: 0; padding-left: 0; }
  }

  /* justify-content */
  &--justify-start   { justify-content: flex-start; }
  &--justify-center  { justify-content: center; }
  &--justify-end     { justify-content: flex-end; }
  &--justify-between { justify-content: space-between; }
  &--justify-around  { justify-content: space-around; }

  /* align-items */
  &--align-start   { align-items: flex-start; }
  &--align-center  { align-items: center; }
  &--align-end     { align-items: flex-end; }
  &--align-stretch { align-items: stretch; }
}
</style>
